import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Terms, Term } from '@/models/Term.model';

// Inital state
const state: Terms = {
  terms: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Terms> = {
  terms: (state) => state.terms,

  termsByCustomer: (state) => (customerId: number): Term[] => {
    return state.terms.filter((item: Term) => {
      return item.customerId === customerId;
    });
  },
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Terms> = {
  setTerms(state, { terms }) {
    state.terms = terms;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Terms, Mutations, Getters> = {
  setTerms({ commit }, payload) {
    commit('setTerms', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Terms, Getters, Mutations, Actions>('TermModule');

export const TermModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
